import axios from 'axios';

const Axios = axios.create({
  headers: {},
});

// Add a response interceptor
Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error?.response?.status === 401 &&
      !window.location.pathname.includes('/auth')
    ) {
      return;
    }
    const errorResponse = {
      ...error?.response?.status,
    };

    if (
      (errorResponse?.code === 153 || errorResponse?.code === 141) &&
      !window.location.pathname.includes('/checkout')
    ) {
      window.location.assign('/');
      return;
    }
    if (errorResponse?.code === 152) {
      window.location.assign('/address-list');
      return;
    }

    if (error?.response?.status)
      return Promise.reject(error.response.data || errorResponse);
  },
);

Axios.interceptors.request.use((config) => {
  config.headers['x-session-id'] = sessionStorage.getItem('sessionId');
  return config;
});

const axiosBaseQuery =
  () =>
  async ({ url, method, data, headers, params, baseURL, responseType }) => {
    try {
      const result = await Axios({
        url,
        method,
        data,
        headers,
        params,
        baseURL,
        responseType,
      });
      return { data: result.data };
    } catch (axiosError) {
      return {
        error: { ...axiosError },
      };
    }
  };

export default axiosBaseQuery;
